import { IApprovedVendor, IApprovedVendorListPayload } from 'companySettings/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getApprovedVendors = async (
  requestPayload: IApprovedVendorListPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IApprovedVendor>> => {
  const { data } = await partfinitiClient.get(
    `/manufacturer_v2/contact-group-location-association-list/list?${getQueryStringToSnakeCase(
      requestPayload
    )}`,
    signal
  );

  return mapRecordsFromServer<IApprovedVendor>(data?.data, data?.recordsFiltered);
};

export const upsertApprovedVendors = async (data: IApprovedVendor[]) =>
  partfinitiClient.postForm('/manufacturer_v2/contact-group-location-association-edit/save', {
    manufacturerContactGroupLocationAssociations: data,
  });

export const removeApprovedVendors = async (data: number[]) =>
  partfinitiClient.postForm('/manufacturer_v2/contact-group-location-association-edit/remove', {
    manufacturerContactGroupLocationAssociations: data,
  });
